// extracted by mini-css-extract-plugin
module.exports = {"inputWrapper":"style_inputWrapper__1_nQQ","inputSingleColumnWrapper":"style_inputSingleColumnWrapper__W5nqS","inputDoubleColumnWrapper":"style_inputDoubleColumnWrapper__3hxxm"};